import React from "react";
import { Route, Routes } from "react-router-dom";

import { ROUTES } from "./routes";
import { AuthLayout } from "@components";
import { SignIn } from "@pages";

export const UnauthenticatedNavigator = () => {
  return (
    <Routes>
      <Route element={<AuthLayout />}>
        <Route path={ROUTES.LOGIN} element={<SignIn />} />
        <Route path={"/*"} element={<SignIn />} />
      </Route>
    </Routes>
  );
};
